<script>
  export let title;
  export let text;
</script>

<div class="w-full h-full flex flex-col justify-center items-center text-center">
    <h1 class="text-7xl">{title}</h1>
    <p class="text-4xl mt-8">
      {text}
    </p>
</div>
